import React, { useEffect } from "react";
import styled from "styled-components";

import "toasted-notes/src/styles.css";
import { ModalWrapper, NormalText } from "../../../../common/common.styles";
import {
    Input,
    InputWrapper,
    Label,
} from "../../../../../AuthenticatedApp/components/productCatalogue/common/common.styles";
import Button, { LightButton } from "../../../../../../library/otherButton/Button";

const SaveModal = ({
    closeModal,
    orderNameValue,
    setOrderNameValue,
    handleSaveOrder,
    isSubmitting,
}) => {
    const handleChange = (e) => setOrderNameValue(e.target.value);

    useEffect(() => {
        document.body.classList.add("backdrop-init");

        return () => {
            document.body.classList.remove("backdrop-init");
        };
    }, [closeModal]);

    return (
        <div className="modal">
            <div className="fadeIn animated modal-backdrop">
                <SaveModalWrapper>
                    <h3>Save Order</h3>
                    <NormalText>
                        Give this order a name to easily find it when you want to checkout.
                    </NormalText>

                    <InputWrapper>
                        <Label>Order Name</Label>
                        <Input
                            type="text"
                            placeholder="Enter a Name"
                            onChange={handleChange}
                            value={orderNameValue}
                        />
                    </InputWrapper>
                    <div className="catalogue-modal__buttons-wrap">
                        <LightButton text="Cancel" width="157.5px" onButtonClick={closeModal} />
                        <Button
                            text="Save"
                            width="157.5px"
                            onButtonClick={handleSaveOrder}
                            isSubmitting={isSubmitting}
                            disabled={orderNameValue === ""}
                        />
                    </div>
                </SaveModalWrapper>
            </div>
        </div>
    );
};

const SaveModalWrapper = styled(ModalWrapper)`
    padding: 40px;
    width: 415px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h3 {
        margin-bottom: 8px;
    }
    p {
        margin-bottom: 32px;
        color: #979797;
        text-align: center;
        b {
            font-weight: 800;
        }
    }
    .catalogue-modal__buttons-wrap {
        margin-top: 40px;
    }
`;

export default SaveModal;
